<template>
  <div class='login_wrap vue_flex vue_column vue_flex_around vue_align_end size_no_repeat' :style="{'width': innerWidth + 'px', 'height': innerHeight + 'px'}">
      <div class="login_wrap_boxs vue_flex vue_column vue_flex_between">
        <div class="login_wrap_boxs_title vue-font-fangyuehei-400 vue_relative">
          广厦OA管理系统
        </div>
        <div class="login_wrap_boxs_div vue_flex_item vue_flex vue_column vue_align_center">
          <p class="login_wrap_boxs_div_text vue-font-PingFang-bold">请选择公司</p>
          <div class="login_wrap_boxs_div_input vue_flex vue_column vue_flex_around width_100">
            <div class="vue_flex">
              <img src="@/assets/images/ic_gs.png" alt="">
              <el-select v-model="tempObj.company" placeholder="请选择">
                <el-option v-for="(company, companyIndex) in companyList" :key="companyIndex" :label="company.company_name" :value="company.id"></el-option>
              </el-select>
            </div>
          </div>
          <div class="login_wrap_boxs_div_but vue-font-PingFang-500" @click='login'>登录</div>
        </div>
      </div>
  </div>
</template>
<script>
import jsmd5 from 'js-md5'
import { windowFun } from "@/utils/utils"
import DonMessage from "@/utils/message";
import Cookies from 'js-cookie'

export default {
  data(){
      return{
        loginName:'test01',
        innerWidth: 0,
        innerHeight: 0,

        tempObj: {
          company: '',
        },

        companyList: [],


      }
  },

  created(){
    this.innerWidth = windowFun().innerWidth
    this.innerHeight = windowFun().innerHeight

    this.companyFun()
  },
  methods:{
    async login(){
      if(!this.tempObj.company) return DonMessage.error(`请选择公司`);
      let companyObj = this.companyList.find(item => Number(item.id) === Number(this.tempObj.company))
      localStorage.setItem('userCompany', JSON.stringify(companyObj));
      if(Cookies.get('userObj')){
        let userObj = JSON.parse(Cookies.get('userObj'))
        if(userObj.id === 1 || userObj.id === 6){   // 劳务
          this.$router.push({ path: '/main/level1/dashboard' });
        }
        if(userObj.id === 3 || userObj.id === 7){   // 财务
          this.$router.push({ path: '/main/level2/dashboard' });
        }
        // if(userObj.id === 8 || userObj.id === 5){   // 招标
        //   this.$router.push({ path: '/main/level3/dashboard' });
        // }
        // if(userObj.id === 4){   // 行政
        //   this.$router.push({ path: '/main/level4/dashboard' });
        // }
      }
    },

    async companyFun(){
      const res = await this.$http.get(this.$urls.getCompanyList, {
        page: 1,
        limit: 1000,
      });
      console.log(res, '00000')
      if(res.errcode === 0){
        this.companyList = res.data.company_list
      } else {
        if(res.errcode === 10006 || res.errcode === 1 || res.errcode === 2){
          DonMessage.error(res.errmsg);
          Cookies.remove('QYS-JWT');
          Cookies.remove('userObj');
          this.$router.push({ path: '/login' });
        } else {
          DonMessage.error(res.errmsg);
        }

      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login_wrap{
  background-image: url("../../assets/images/ic_dl_bg.png");
  .login_wrap_boxs{
    width: 543px;
    height: 640px;
    margin-right: 222px;
    background: #2274EF;
    box-shadow: 0px 0px 48px 0px rgba(5,42,97,0.2);
    border-radius: 30px;
    .login_wrap_boxs_title{
      font-size: 30px;
      color: #FFFFFF;
      line-height: 30px;
      margin: 41px 0px 37px;
      text-align: center;
      img{
        width: 36px; height: 36px; top: 0px; left: 26px;
      }
    }
    .login_wrap_boxs_div{
      background: #FFFFFF; border-radius: 30px; padding: 0px 58px;
      .login_wrap_boxs_div_text{
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        margin: 41px 0px 104px;
      }
      .login_wrap_boxs_div_input{
        height: 74px; background: rgba(245, 249, 252, 1); border-radius: 9px; padding: 0px 22px 0px 26px;
        img{
          width: 36px; height: 36px;
        }
      }

      .login_wrap_boxs_div_but{
        width: 408px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        background: #2274EF;
        border-radius: 33px;
        margin: 136px auto 0px;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
}

/deep/.el-select{
  width: -webkit-fill-available !important;
}
.el-select /deep/.el-input__inner{
  border: none !important;
  background: none !important;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/pages/company/company.vue